module.exports = __webpack_public_path__ + "315aaca628c798c42bee070703f17e55.jpeg";